import { render, staticRenderFns } from "./ImageColorPicker.vue?vue&type=template&id=0826fab0&"
import script from "./ImageColorPicker.vue?vue&type=script&lang=js&"
export * from "./ImageColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports